import { API_URL } from '@/env'
import axios from 'axios'

export type ErrorType = {
  error: string
}

const client = axios.create({ baseURL: API_URL })

/* client.interceptors.request.use((config) => {
  try {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_JWT) || '')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (error) {
    console.error('Error reading token', error)
  }

  return config
}) */

export const api = {
  get: <T>(url: string): Promise<T> => client.get(url).then(({ data }) => data),
  post: <T>(url: string, data?: any): Promise<T> => client.post(url, data).then(({ data }) => data)
}
